import { SVGProps } from "react";

/**
 * Heroicons has no slashed microphone in any of its four sets, so this is the
 * one control icon we draw ourselves. It is the heroicons 24/outline
 * MicrophoneIcon path with their slash across it, at their stroke weight and
 * on currentColor — otherwise it lands among the others as a filled grey glyph
 * where they are all white outlines.
 */
export default function NoMicrophoneIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z" />
      <path d="M3 3l18 18" />
    </svg>
  );
}
